export function concatParameterUnits(parameterUnits) {
    return parameterUnits.join(",");
}
//# sourceMappingURL=apiFormat.js.map